import React from "react";

export default function statusAfstanden(color){
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			id="Laag_3"
			viewBox="0 0 51 35"
			width="51px"
			height="80px"
			version="1.1"
			xmlSpace="preserve"
			>
				<g transform="matrix(1.33333 0 0 -1.33333 0 40.933)">
				<g
				fill="none"
				stroke="#231f20"
				strokeDasharray="none"
				strokeLinecap="butt"
				strokeLinejoin="miter"
				strokeMiterlimit="10"
				strokeOpacity="1"
				strokeWidth="10"
				transform="scale(.1)"
				>
				<path fill={"#E6332A"} d="M288.102 142.609H170.023v53.133h118.079l35.429-26.57z"></path>
				<path fill={"#E6332A"} d="M336.078 248.879H170.023v53.133h166.055l35.422-26.567z"></path>
				<path fill={"#E6332A"} d="M43.922 195.742h126.101v53.137H43.922L8.5 222.309z"></path>
				<path fill={"#E6332A"} d="M170.023 302.012V33.379"></path>
				<path fill={"#E6332A"} d="M-.004 33.262h380"></path>
				<path fill={"#E6332A"} d="M-.004 5h380"></path>
				</g>
				</g>
		</svg>
	);
}